import React, { useEffect, useState } from 'react';
import useManageCrud from '#src/@manage/use-manage.js';
import { DashboardTable } from './tables.jsx';
import CallTo from './call-to.jsx';
import HowToList from './how-to-list.jsx';
import { Navigate } from 'react-router-dom';
import useAuth, { DEFAULT_AUTH_ROUTES as AUTH_ROUTES } from '#lib/hooks/use-auth.jsx';
import ConnectionsCard from './connections-card.jsx';
import TasksCard from './tasks-card.jsx';
import ManageControls from '#components/manage-controls.jsx';
import PackageCard from './package-card.jsx';

const IMAGES = [
    'https://images.unsplash.com/photo-1476362174823-3a23f4aa6d76?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    'https://images.unsplash.com/photo-1630582750965-0ad2435b8c75?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    'https://images.unsplash.com/photo-1548585742-1df49e753a83?q=80&w=1777&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    'https://images.unsplash.com/photo-1511713242480-1fc71db2c0ad?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'
];

export default function Home() {
    const { data: itineraries, isLoading } = useManageCrud('itinerary');
    const { user, isAuthenticated } = useAuth();
    const [imageIndex, setImageIndex] = useState(0);

    // Change image every 10 seconds
    useEffect(() => {
        const interval = setInterval(() => {
            setImageIndex((prev) => (prev + 1) % IMAGES.length);
        }, 10000);

        return () => clearInterval(interval);
    }, []);

    if (!isAuthenticated) return <Navigate to={`../${AUTH_ROUTES.SIGN_IN}`} state={{ from: '/' }} />;

    return (
        <ManageControls.Provider hideControls={true}>
            <main className="relative flex flex-col items-center justify-center w-full md:h-full">
                <div className="md:absolute flex flex-col gap-3 w-full min-w-[300px] max-w-[1100px] h-[660px] mt-14 md:mt-6 md:top-1/2 md:-translate-y-1/2 mb-10">
                    <h2 className="hidden md:block w-full text-center font-bold text-2xl md:text-3xl lg:text-4xl text-primary-600">
                        {_t.home.callToText()}
                    </h2>
                    <div className="w-full md:h-[300px] flex flex-col md:flex-row gap-3">
                        <div className="relative w-full md:w-2/3 h-[300px] md:h-full md:shadow-lg md:rounded-xl overflow-hidden border-b border-b-neutral-200 md:border-none">
                            {IMAGES.map((src, index) => (
                                <img
                                    key={index}
                                    src={src}
                                    alt="placeholder"
                                    className={`absolute top-0 left-0 w-full h-full object-cover transition-opacity duration-1000 ${index === imageIndex ? 'opacity-100' : 'opacity-0'
                                        }`}
                                />
                            ))}
                            <CallTo />
                        </div>
                        <HowToList />
                    </div>
                    <div className="w-full md:h-[300px] flex flex-col md:flex-row gap-3 justify-between">
                        <div className="w-full md:w-2/3 flex flex-col md:flex-row md:gap-2">
                            <TasksCard itineraries={itineraries?.pages[0].results} isLoading={isLoading} />
                            <PackageCard />
                        </div>
                        <DashboardTable
                            isLoading={isLoading}
                            headings={['Title', 'Edit']}
                            items={itineraries?.pages[0].results.slice(0, 5)}
                            type="Itineraries"
                            to="/manage/itinerary/search"
                        />
                    </div>
                </div>
            </main>
        </ManageControls.Provider>
    );
}
